import { useEffect, useState } from "react";
import DashboardLayout from "../../layouts/DashboardLayout";
import { api, money } from "../../api/client";

export default function AdminBookings() {
  const [rows, setRows] = useState([]);

  useEffect(() => {
    api("/api/admin/reservations").then(setRows).catch(() => setRows([]));
  }, []);

  return (
    <DashboardLayout title="All reservations">
      <div className="overflow-x-auto card">
        <table className="min-w-full text-left text-sm">
          <thead className="text-xs uppercase tracking-[0.16em] text-ink/45">
            <tr>
              <th className="px-5 py-4">Guest</th>
              <th className="px-5 py-4">House</th>
              <th className="px-5 py-4">When</th>
              <th className="px-5 py-4">Total</th>
              <th className="px-5 py-4">Status</th>
            </tr>
          </thead>
          <tbody>
            {rows.map((row) => (
              <tr key={row.id} className="border-t border-ink/5">
                <td className="px-5 py-4">
                  <p className="font-medium">{row.guestName}</p>
                  <p className="text-ink/50">{row.guestEmail}</p>
                </td>
                <td className="px-5 py-4">{row.venueName}</td>
                <td className="px-5 py-4">
                  {row.type === "event" ? row.eventDate : `${row.checkIn} → ${row.checkOut}`}
                </td>
                <td className="px-5 py-4">{money(row.total)}</td>
                <td className="px-5 py-4">
                  <span className="chip bg-blush/70 capitalize">{row.status}</span>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </DashboardLayout>
  );
}
